"use client";

import { ProductDetailsResponse } from "@/types/product";
import React, { useRef } from "react";
import Image from "next/image";
import Slider from "react-slick";
import ViewAllButton from "../view-all-button/ViewAllButton";
import { Typography } from "../typography";
import { FeatureProductsMobile } from "./feature-products-mobile";
import { ProductCardUI } from "../product-card/product-card-ui";

export interface ProductsResponse {
  id: number;
  image: string;
  images: string[];
  description: string;
  slug: string;
  name: string;
  flatDiscount: number;
  price: number;
  shippingFee: number;
}

export default ({
  productsData,
}: {
  productsData: ProductDetailsResponse[];
}) => {
  const sliderRef = useRef<Slider>(null);

  if (productsData.length < 1) {
    return null;
  }

  const handlePrevClick = () => {
    sliderRef.current?.slickPrev();
  };

  const handleNextClick = () => {
    sliderRef.current?.slickNext();
  };

  return (
    <div className="bg-pageBg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between my-4 items-center">
          <div className="w-full lg:w-auto">
            <Typography
              tag="h1"
              className="text-left text-[1.5em] sm:text-[1.7em]"
            >
              New Arrivals
            </Typography>
          </div>
          <div className="flex gap-2 sm:gap-4 lg:hidden">
            <button
              onClick={handlePrevClick}
              className="transition-all rounded-full p-2 sm:p-3 border shadow border-primary hover:scale-105 hover:shadow-md active:scale-100"
            >
              <Image
                src="/img/arrow-left-slide.svg"
                alt="Previous"
                width={20}
                height={20}
              />
            </button>
            <button
              onClick={handleNextClick}
              className="transition-all rounded-full p-2 sm:p-3 border shadow border-primary hover:scale-105 hover:shadow-md active:scale-100"
            >
              <Image
                src="/img/arrow-right-slide.svg"
                alt="Next"
                width={20}
                height={200}
              />
            </button>
          </div>
          {/* <div className="hidden lg:block">
            <ViewAllButton />
          </div> */}
        </div>
      </div>
      <div className="container px-4 lg:px-2">
        {/* Desktop: grid so every row has equal-height cards */}
        <div className="hidden lg:grid lg:grid-cols-4 gap-2 items-stretch">
          {productsData.map((product) => (
            <div
              key={product.slug}
              className="min-h-0 h-full [&>*]:max-w-full [&>*]:w-full"
            >
              <ProductCardUI
                product={product}
                pageType="featureProducts"
              />
            </div>
          ))}
        </div>

        {/* Conditionally render original layout for large screens */}
        <FeatureProductsMobile data={productsData} sliderRef={sliderRef} />

        <div className=" flex  items-center justify-center my-4">
          <ViewAllButton />
        </div>
      </div>
    </div>
  );
};
